module.exports = __webpack_public_path__ + "static/payouts-foreground-804d809b3be775a34d07989af9c97496.png";